(($) => {

    const $addMediaBlockBtn = $('#add-media-block');

    if($addMediaBlockBtn.lenght === 0) {
        return;
    }

    const $mediaBlocksContainer = $('#media-blocks-container');
    let blockIdx = $mediaBlocksContainer.find('.row').length;

    const handleRemovalBtn = () => {
        const $removeMediaBlockBtn = $('.remove-media-block');
        if($removeMediaBlockBtn.length ===0) {
            return;
        }
        $removeMediaBlockBtn.click(function (e) {
            e.preventDefault();
            $(e.target).parent().remove();
        });
    }

    handleRemovalBtn();

    $addMediaBlockBtn.click( e => {
        e.preventDefault();
        fetch('/admin/cms-publish/media-block', {cache: 'force-cache'})
          .then(response=> response.text())
          .then(text => {
              $mediaBlocksContainer.append(
                text.replaceAll('[idx]', `[new_${blockIdx.toString()}]`)
              );
              blockIdx++;

              handleRemovalBtn();
          });
    });
})($);